import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../styles/Slider-swiper.css";

const ModalImagen = ({ imageArray, open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      showCloseIcon={false}
      styles={{
        modal: {
          padding: "0px",
          borderRadius: "12px",
          maxWidth: "90vw",
          width: "600px"
        },
      }}
    >
      <div className="text-center">
        <Swiper
          modules={[Autoplay,Navigation, EffectFade, Pagination]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          navigation={true}
          pagination={{ clickable: true }}
          slidesPerView={1}
          effect="fade"
          loop={true}
          className="w-100"
        >
          {imageArray.map((imageObj, index) => (
            <SwiperSlide key={index} className="h-auto">
              <a
                href={imageObj.url}
                onClick={onClose}
                style={{ outline: "none" }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    maxHeight: "80vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={imageObj.img}
                    alt="Aviso"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                      display: "block",
                    }}
                  />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Modal>
  );
};

export default ModalImagen;
